;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	const Model = APP.module('Model');

	Model.LoginFormBuilder = Backbone.Model.extend({
		url: function() {
			return this.methodUrl;
		},
		initialize: function(){
			this.changeBuilderModel();
		},
		defaults: {
			layout_login: 'LoginForm',
			layout_password_recovery: 'LoginFormLeft',
			layout_send_token: 'LoginFormLeft',
			side_bar_enabled: false,
			side_bar_widgets: []
		},
		changeBuilderModel: function(){
			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));
